import { default as module } from './AbstractModule';
import { $document, html } from '../utils/environment'
import { getData } from '../utils/html'
import ScrollManager from '../scroll/ScrollManager';
import { EVENT as SCROLL_EVENT } from '../scroll/Scroll';

export default class extends module {
    constructor(m) {
        super(m);

        this.isMain = getData(this.getData('main'))
        this.isTop = false

        document.documentElement.classList.add('is-top')

        window.app.scroll = {
            x: 0,
            y: 0
        }

        this.images = Array.from(this.el.querySelectorAll('img')).filter(img => !img.complete)
    }

    init() {
        this.scroll = new ScrollManager({
            container: $(this.el),
            smooth: true,
            inertia: 1,
            getDirection: true,
            onScroll: (e) => {
                // console.log(e);
                if(!e || !e.scroll) return

                if(e.scroll.direction == 'down')
                    html.classList.add('is-scrolling-down')
                else
                    html.classList.remove('is-scrolling-down')

                if(this.scroll) {
                    let scrollValue = e.scroll.y
                    if(this.scroll.instance && this.scroll.instance.instance && this.scroll.instance.instance.delta) scrollValue = this.scroll.instance.instance.delta.y

                    if(!this.isTop && scrollValue == 0) {
                        this.isTop = true
                        document.documentElement.classList.add('is-top')
                    } else if(this.isTop && scrollValue > 0) {
                        this.isTop = false
                        document.documentElement.classList.remove('is-top')
                    }

                    if(this.isMain) {
                        window.app.scroll.direction = e.scroll.direction
                        window.app.scroll.y = e.scroll.y
                        $document.triggerHandler({ type: SCROLL_EVENT.SCROLLING })
                    }

                    if(window.app.hasIntro && this.isMain && !window.app.introScrollRequested && scrollValue == 0 && e.scroll.direction == 'up')
                        this.call('enableScroll', 500, 'Intro');
                }
            }
        });

        let scope = this
        for(let img of this.images) {
            this.onImageLoad = function() {
                requestAnimationFrame(scope.update.bind(scope));
                scope.update()
                this.removeEventListener('load', this.onImageLoad)
            }
            img.addEventListener('load', this.onImageLoad)
        }

        this.onUiDarkTrigger = (e) => {
            if(e.options.direction != undefined) {
                if(window.app.scroll.direction === e.options.direction) {
                    if(e.way === e.options.way) {
                        document.documentElement.classList.remove('has-white-logo');
                        document.documentElement.classList.remove('has-dark-header');
                    }
                }
            } else {
                document.documentElement.classList.remove('has-white-logo');
                document.documentElement.classList.remove('has-dark-header');
            }
        }
        $document.on(SCROLL_EVENT.TRIGGER_UI_DARK, this.onUiDarkTrigger);

        this.onUiLightTrigger = (e) => {
            if(e.options.direction != undefined) {
                if(window.app.scroll.direction === e.options.direction) {
                    if(e.way === e.options.way) {
                        document.documentElement.classList.add('has-white-logo');
                        document.documentElement.classList.add('has-dark-header');
                    }
                }
            } else {
                document.documentElement.classList.add('has-white-logo');
                document.documentElement.classList.add('has-dark-header');
            }
        }
        $document.on(SCROLL_EVENT.TRIGGER_UI_LIGHT, this.onUiLightTrigger);
    }

    scrollTo(options) {
        this.scroll.instance.scrollTo(options)
    }

    update() {
        this.scroll.instance.update()
        $document.triggerHandler({ type: SCROLL_EVENT.SCROLLING })
    }

    destroy() {
        for(let img of this.images) {
            img.removeEventListener('load', this.onImageLoad)
        }

        $document.off(SCROLL_EVENT.TRIGGER_UI_DARK, this.onUiDarkTrigger);
        $document.off(SCROLL_EVENT.TRIGGER_UI_LIGHT, this.onUiLightTrigger);
        this.scroll.destroy();
    }
}
